import { subscribe } from 'valtio'

import {
  floorInitState,
  floorState,
  isParticipantCameraAloneInFloor,
  isParticipantCameraInFloor,
  isParticipantMobileInFloor,
  isParticipantScreenInFloor,
} from '../../firebase/hooks/useFloor'
import { roomState, setVideoTrackQuality } from '../webRTCRoom'
import { panelState } from '../../firebase/hooks/usePanel'
import { trayState } from '../../firebase/hooks/useTray'

const syncRemoteTracksQuality = () => {
  const remoteParticipants = roomState.participants.filter((p) => !p.isLocal)

  // wait for the floor to be initialized
  if (!floorInitState.isFloorReady || !floorState.floor) return

  remoteParticipants.forEach((p) => {
    if (isParticipantCameraInFloor(p.id, floorState.floor, panelState)) {
      if (isParticipantCameraAloneInFloor(p.id, floorState.floor, panelState)) {
        setVideoTrackQuality(p.id, 'camera', 'high')
      } else {
        setVideoTrackQuality(p.id, 'camera', 'standard')
      }
    } else {
      setVideoTrackQuality(p.id, 'camera', 'low')
    }

    // screen
    if (
      isParticipantScreenInFloor(p.id, floorState.floor, panelState, trayState)
    ) {
      setVideoTrackQuality(p.id, 'screen', 'high')
    } else {
      setVideoTrackQuality(p.id, 'screen', 'low')
    }

    // mobile
    if (isParticipantMobileInFloor(p.id, floorState.floor)) {
      setVideoTrackQuality(p.id, 'mobile', 'high')
    } else {
      setVideoTrackQuality(p.id, 'mobile', 'low')
    }
  })
}

/// ////////////////////////////// ///
/// initialization and destruction ///
/// ////////////////////////////// ///

const subscriptions: (() => void)[] = []

const init = () => {
  subscriptions.push(subscribe(roomState.participants, syncRemoteTracksQuality))
  subscriptions.push(subscribe(floorState, syncRemoteTracksQuality))
  subscriptions.push(subscribe(trayState, syncRemoteTracksQuality))
  syncRemoteTracksQuality()
}

const destroy = () => {
  while (subscriptions.length > 0) {
    subscriptions.shift()?.()
  }
}

export { syncRemoteTracksQuality, init, destroy }
